import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ARROW_LEFT_ICON, PLUS_ICON } from '../assets/image';
import style from './BoardList.module.css';
import SaveTemplate from 'components/SaveTemplate';
import SaveModalKanban from 'components/SaveModalKanban';
import boardToast, { TOAST_TYPE } from '../utils/boardToast';
import Archived from '../../../../../src/assets/img/archived.svg';
import SaveTemplete from '../../../../../src/assets/img/save-templete.svg';
import { useSocket } from '../context/SocketContext';
import EDIT_ICON from 'assets/img/edit-01.svg';

export default function BoardList({
  boards,
  projectBoardId,
  handleProjectClick,
  handleAddBoard,
  handleSubmit,
  setShowSavedTemplates,
  showSavedTemplates,
  handleSavedTemplateClick,
  isTemplateActive,
  showArchivedList,
  isArchivedActive,
  isArchivedParent,
  handleEditTitle,
  setBoards,
  currentUserId,
  canCreateBoard = false
}) {
  const socket = useSocket();
  const navigate = useNavigate();
  const [saveOpen, setSaveOpen] = useState(false);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [boardTitle, setBoardTitle] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [editBoardId, setEditBoardId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const canEditBoard = (board) => {
    if (!board || !currentUserId) return false;

    const createdById = board.createdBy?._id || board.createdBy;
    if (createdById?.toString() === currentUserId.toString()) return true;

    const membership = board.teams?.find((team) => {
      const teamUserId = team.userId?._id || team.userId;
      return teamUserId?.toString() === currentUserId.toString();
    });

    return (membership?.permission?.name || membership?.permission) === 'Edit';
  };

  const handleBackClick = () => {
    navigate('/project-boards', {
      state: {
        showBack: false
      }
    });
  };

  const handleCreateNewBoard = () => {
    setSaveOpen(false);
    setSaveModalOpen(true);
  };

  const handleUseSavedTemplate = () => {
    setSaveOpen(false);
    // Show coming soon message
    boardToast('Coming Soon!', TOAST_TYPE.INFO);
  };

  const handleSaveBoard = async (title) => {
    try {
      setIsSaving(true);
      await handleSubmit(title);
      setSaveModalOpen(false);
      setBoardTitle('');
    } catch (error) {
      console.error('Error saving board:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleEditBoard = async (title) => {
    try {
      setIsSaving(true);
      socket.emit('update-project-board', {
        id: editBoardId,
        payload: { name: title }
      });

      setBoards((prevState) =>
        prevState.map((state) => {
          if (state._id === editBoardId) {
            return { ...state, name: title };
          }
          return state;
        })
      );

      setSaveModalOpen(false);
      setBoardTitle('');
      setEditBoardId(null);
      setIsEditMode(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={`${style.board_list_wrapper} `}>
      {/* <div className={style.back_arrow_button_wrapper} onClick={handleBackClick}>
        <img src={ARROW_LEFT_ICON} alt="arrow-left" className='back-to-boards'/>
        <div className={style.text_content}>Back</div>
      </div> */}
      {/* {!isArchivedParent && ( */}
        {/* <> */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="title boards-title">Your Boards</div>
            {!isArchivedParent && canCreateBoard && <div>
              {/* <button className="btn btn-light icon-btn" onClick={handleAddBoard}> */}
              <button
                className="btn btn-light icon-btn"
                onClick={() => {
                  setSaveModalOpen(true);
                }}>
                <img src={PLUS_ICON} alt="search-icon" className="search-icon-right" />
              </button>
            </div>}
          </div>
          <div className={style.board_item_wrapper}>
            <div className={style.board_list_scroller}>
              {console.log(boards)}
              {boards.map((value) => (
                <div
                  className={`${style.board_item} mb-2 ${
                    projectBoardId === value?._id && !isTemplateActive && !showSavedTemplates ? 'active' : ''
                  }`}
                  title={value.name  || value.workspaceName}
                  onClick={() => handleProjectClick(value?._id)}
                  key={value._id || 'NEW'}>
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <span onClick={() => handleProjectClick(value?._id)} className="text-ellipsis">
                      {value.name || value.workspaceName}
                    </span>

                    {!isArchivedParent && canEditBoard(value) && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsEditMode(true);
                          setEditBoardId(value._id);
                          setBoardTitle(value.name || value.workspaceName);
                          setSaveModalOpen(true);
                        }}
                        style={{ cursor: 'pointer', marginLeft: '8px' }}>
                        <img
                        src={EDIT_ICON}
                        alt="edit"
                        className={style.board_edit_icon}
                        // onClick={() => setShowEditMode(true)}
                        />
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className={`${style.board_item_cover}`}>
              {!isArchivedParent && (
                <div
                  className={`${style.board_item} mb-2 d-flex ${showArchivedList || isArchivedActive ? 'active' : ''}`}
                  onClick={() => {
                    handleSavedTemplateClick(true, true);
                  }}>
                  <img src={Archived} alt="archived-icon" className="archived-icon" />
                  Closed
                </div>
              )}
              <div
                className={`${style.board_item} mb-2  d-flex ${showSavedTemplates || isTemplateActive ? 'active' : ''}`}
                onClick={() => {
                  handleSavedTemplateClick(true);
                }}>
                <img src={SaveTemplete} alt="archived-icon" className="archived-icon" />
                Saved Templates
              </div>
            </div>
          </div>
        {/* </>
      )} */}
      <SaveTemplate
        show={saveOpen}
        onHide={() => {
          setSaveOpen(false);
        }}
        onCreateNewBoard={handleCreateNewBoard}
        onUseSavedTemplate={handleUseSavedTemplate}
      />
      <SaveModalKanban
        show={saveModalOpen}
        onHide={() => {
          setSaveModalOpen(false);
          setBoardTitle('');
          setIsEditMode(false);
        }}
        isCreateBoard={true}
        isEditingBoard={isEditMode}
        onSave={(title) => (isEditMode ? handleEditBoard(title) : handleSaveBoard(title))}
        title={boardTitle}
        onTitleChange={setBoardTitle}
        isLoading={isSaving}
      />
    </div>
  );
}
